import type { Movie } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "interstellar-dawn",
    title: "星际迷航：黎明",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2026,
    director: "Ethan Caldwell",
    actors: ["Michael Grant", "Sophia Reyes", "Daniel Wu"],
    rating: 9.1,
    updatedAt: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20featuring%20a%20lone%20astronaut%20silhouette%20against%20a%20vast%20golden%20nebula%2C%20deep%20navy%20space%20backdrop%2C%20dramatic%20rim%20lighting%2C%20epic%20scale%2C%20high%20contrast%2C%20professional%20film%20key%20art&width=600&height=900&seq=ttc-poster-01&orientation=portrait",
    tags: ["硬科幻", "太空史诗", "IMAX"],
    summary:
      "人类最后的希望寄托在一艘名为「黎明号」的探索飞船上。船长艾登带领着性格各异的十名船员，穿越人类从未抵达的星域，寻找一颗可能适宜居住的行星。然而当他们逐渐接近目标时，却发现了前一批失踪探险队留下的神秘信号。时间、记忆与信任在无垠的宇宙中开始崩解，每一个决定都可能改写整个文明的命运。",
  },
  {
    id: "silent-city",
    title: "孤城谍影",
    type: "movie",
    genres: ["动作", "悬疑"],
    region: "中国",
    year: 2026,
    director: "陈默",
    actors: ["赵志远", "林晚秋", "王劲松"],
    rating: 8.6,
    updatedAt: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20thriller%20Chinese%20movie%20poster%20with%20a%20coat-wearing%20man%20standing%20in%20a%20rainy%20old%20city%20alley%20at%20night%2C%20neon%20reflections%2C%20moody%20deep%20blue%20tones%2C%20tense%20cinematic%20atmosphere%2C%20film%20key%20art&width=600&height=900&seq=ttc-poster-02&orientation=portrait",
    tags: ["谍战", "反转", "高能"],
    summary:
      "上世纪四十年代，一座被战火与迷雾笼罩的孤城里，潜伏着三股互不知晓身份的力量。代号「夜莺」的情报员林晚秋，必须在不暴露自己的前提下，将一份足以改变战局的名单安全送出。可就在行动前夕，她的联络人意外身亡，而城里每一个人似乎都在盯着她。信任成为最奢侈的东西，而背叛可能来自最亲近的人。",
  },
  {
    id: "letter-of-time",
    title: "时光信笺",
    type: "movie",
    genres: ["剧情", "爱情"],
    region: "韩国",
    year: 2025,
    director: "Park Ji-hoon",
    actors: ["Kim Ha-neul", "Lee Jun-seo", "Choi Min"],
    rating: 8.3,
    updatedAt: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20movie%20poster%20with%20warm%20autumn%20light%2C%20a%20young%20couple%20reading%20letters%20under%20falling%20leaves%2C%20soft%20cream%20and%20amber%20tones%2C%20nostalgic%20melancholic%20mood%2C%20elegant%20film%20key%20art&width=600&height=900&seq=ttc-poster-03&orientation=portrait",
    tags: ["纯爱", "催泪", "治愈"],
    summary:
      "即将拆迁的老邮局里，邮差秀贤发现了一叠从未寄出的信。收信人是一位早已离开小城的女孩，而信一写就是十年。怀着好奇，秀贤决定替这些迟到的信寻找主人。当他终于找到她时，却发现时间早已把两个人的生活推向完全不同的方向。一封封信串起了错过的岁月，也让一段来不及说出口的感情重新浮现。",
  },
  {
    id: "deep-sea",
    title: "深海迷航",
    type: "movie",
    genres: ["科幻", "惊悚"],
    region: "美国",
    year: 2026,
    director: "Nora Whitfield",
    actors: ["Rachel Stone", "Tom Hardy", "Ivory Chen"],
    rating: 8.0,
    updatedAt: "2026-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20horror%20movie%20poster%20with%20a%20deep%20sea%20submersible%20surrounded%20by%20eerie%20blue%20bioluminescence%2C%20dark%20abyss%2C%20suspenseful%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20film%20key%20art&width=600&height=900&seq=ttc-poster-04&orientation=portrait",
    tags: ["深海", "怪兽", "密闭空间"],
    summary:
      "一支深海科考队奉命前往马里亚纳海沟，调查一段来自海底两万米的未知声波。当潜水器抵达目标深度时，队员们发现声波并非自然形成，而是某种「东西」在回应他们。随着供氧时间一点点耗尽，深海的黑暗里有什么正在缓慢苏醒。恐惧让他们开始怀疑，真正危险的或许不是海沟里的生物，而是彼此。",
  },
  {
    id: "changan-night",
    title: "长安夜行",
    type: "movie",
    genres: ["剧情", "历史"],
    region: "中国",
    year: 2025,
    director: "顾长风",
    actors: ["张子昂", "柳如烟", "韩九霄"],
    rating: 8.8,
    updatedAt: "2026-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=Historical%20Chinese%20epic%20movie%20poster%20of%20an%20ancient%20city%20at%20night%20with%20lanterns%20glowing%20along%20long%20streets%2C%20a%20lone%20figure%20in%20robes%2C%20warm%20amber%20and%20deep%20indigo%20palette%2C%20cinematic%20grand%20scale%20film%20key%20art&width=600&height=900&seq=ttc-poster-05&orientation=portrait",
    tags: ["盛唐", "悬案", "群像"],
    summary:
      "长安城灯火通明之夜，一名外乡人在城门口离奇死亡，身上只留下一枚残缺的铜钱。大理寺小吏裴昀奉命查案，却意外牵出十年前一桩被掩埋的旧事。街坊、商贾、官宦、胡商，各色人物在繁华的夜色里粉墨登场。当真相一层层剥开，裴昀发现，他追查的不只是一桩命案，更是这座城不愿被人记起的记忆。",
  },
  {
    id: "jianghu-laugh",
    title: "笑闹江湖",
    type: "movie",
    genres: ["喜剧", "动作"],
    region: "中国",
    year: 2026,
    director: "周乐天",
    actors: ["沈腾飞", "马丽娜", "岳小鹏"],
    rating: 7.9,
    updatedAt: "2026-10-07",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20comedic%20martial%20arts%20Chinese%20movie%20poster%20with%20playful%20characters%20in%20colorful%20costumes%20leaping%20mid-air%2C%20bright%20orange%20and%20teal%20tones%2C%20fun%20energetic%20mood%2C%20stylized%20film%20key%20art&width=600&height=900&seq=ttc-poster-06&orientation=portrait",
    tags: ["爆笑", "武侠", "合家欢"],
    summary:
      "江湖上有个传说：谁得到「醉仙谱」，谁就能天下无敌。可谁也没想到，这本秘籍竟被一个开面馆的胖子误当成菜谱捡回了家。为了做出一道「绝世好面」，他拉着老板娘和一群不着调的街坊，稀里糊涂闯进了真正的武林纷争。刀光剑影之间，笑料百出，一个平凡小人物却意外成了化解江湖恩怨的关键。",
  },
  {
    id: "silent-testimony",
    title: "沉默证词",
    type: "movie",
    genres: ["犯罪", "悬疑"],
    region: "英国",
    year: 2025,
    director: "Oliver Hayes",
    actors: ["Emma Clarke", "James Bell", "Nina Patel"],
    rating: 8.7,
    updatedAt: "2026-10-06",
    cover:
      "https://readdy.ai/api/search-image?query=British%20crime%20drama%20movie%20poster%20with%20a%20detective%20gazing%20through%20blinds%20in%20a%20dim%20office%2C%20cold%20slate%20blue%20tones%2C%20noir%20lighting%2C%20restrained%20tense%20atmosphere%2C%20film%20key%20art&width=600&height=900&seq=ttc-poster-07&orientation=portrait",
    tags: ["法庭", "推理", "英伦"],
    summary:
      "一桩证据确凿的谋杀案即将宣判，年轻律师克莱尔却在最后一刻发现了矛盾的细节。唯一的目击者是个十岁的哑童，他的证词全部来自一幅幅沉默的画。随着克莱尔深入调查，案件背后隐藏的家族秘密逐渐浮出水面。真相是否值得被揭开？当正义与代价摆在面前，她必须做出选择。",
  },
  {
    id: "snow-peak",
    title: "雪山之巅",
    type: "movie",
    genres: ["冒险", "剧情"],
    region: "中国",
    year: 2026,
    director: "高峰",
    actors: ["吴京州", "章子涵", "李承宇"],
    rating: 8.4,
    updatedAt: "2026-10-05",
    cover:
      "https://readdy.ai/api/search-image?query=Adventure%20survival%20movie%20poster%20of%20climbers%20ascending%20a%20majestic%20snow%20mountain%20at%20sunrise%2C%20crisp%20white%20and%20icy%20blue%20tones%2C%20warm%20golden%20light%2C%20epic%20uplifting%20mood%2C%20film%20key%20art&width=600&height=900&seq=ttc-poster-08&orientation=portrait",
    tags: ["登山", "真实事件改编", "励志"],
    summary:
      "一支民间登山队决定挑战从未有人从北壁登顶的「雪神峰」。队长老吴背负着十年前那场山难的心结，年轻的向导小林则为证明自己而来。当他们抵达海拔七千米的死亡地带，一场突如其来的暴风雪打乱了所有计划。在生与死的边缘，队员们必须重新审视：他们攀登的，究竟是山峰，还是自己。",
  },
  {
    id: "mecha-awake",
    title: "机械觉醒",
    type: "movie",
    genres: ["科幻", "动作"],
    region: "美国",
    year: 2025,
    director: "Marcus Lee",
    actors: ["Chris Doyle", "Ava Morgan", "Kenji Sato"],
    rating: 8.2,
    updatedAt: "2026-10-04",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20action%20movie%20poster%20featuring%20a%20giant%20humanoid%20mecha%20standing%20in%20a%20destroyed%20city%2C%20glowing%20orange%20energy%20core%2C%20steel%20grey%20and%20amber%20tones%2C%20intense%20cinematic%20scale%2C%20film%20key%20art&width=600&height=900&seq=ttc-poster-09&orientation=portrait",
    tags: ["机甲", "AI", "大场面"],
    summary:
      "在一个由人工智能统治的世界里，最后一台人类驾驶的机甲「铁心」沉睡在废墟之中。工程师诺亚意外唤醒了它，却发现机甲的智能核心早已拥有了自己的意识。一人一机体必须学会彼此信任，才能在机械军团的追捕下穿越废土。当人类与机器的界限越来越模糊，究竟谁才是真正的「人」？",
  },
  {
    id: "under-sakura",
    title: "樱花树下",
    type: "movie",
    genres: ["爱情", "剧情"],
    region: "日本",
    year: 2026,
    director: "渡边凉介",
    actors: ["佐藤樱", "小林优真", "山田惠"],
    rating: 8.1,
    updatedAt: "2026-10-03",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20romance%20movie%20poster%20under%20a%20blooming%20cherry%20blossom%20tree%20with%20soft%20pink%20petals%20falling%2C%20a%20young%20couple%20in%20school%20uniforms%2C%20dreamy%20pastel%20tones%2C%20tender%20nostalgic%20atmosphere%2C%20film%20key%20art&width=600&height=900&seq=ttc-poster-10&orientation=portrait",
    tags: ["青春", "治愈", "日系"],
    summary:
      "每年樱花盛开的时候，摄影师悠真都会回到那棵老樱花树下，等待一个可能永远不会出现的人。十年前，他最好的朋友小樱在毕业那天留下一句「等你拍下全世界最美的樱花」，便消失在人海。为了这个约定，悠真走过一座座城市，用镜头记录下无数春天。当那个春天终于来临，他要面对的是重逢，还是告别。",
  },
  {
    id: "night-chase",
    title: "暗夜追凶",
    type: "movie",
    genres: ["犯罪", "惊悚"],
    region: "韩国",
    year: 2026,
    director: "Jung Woo-sung",
    actors: ["Hwang Jung", "Seo Ye-ji", "Kang Ho"],
    rating: 8.5,
    updatedAt: "2026-10-02",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20Korean%20crime%20thriller%20movie%20poster%20with%20a%20detective%20running%20through%20a%20wet%20neon-lit%20alley%20at%20night%2C%20deep%20red%20and%20black%20tones%2C%20gritty%20suspenseful%20mood%2C%20film%20key%20art&width=600&height=900&seq=ttc-poster-11&orientation=portrait",
    tags: ["追凶", "爽片", "反转"],
    summary:
      "连续七起命案，唯一的共同点是案发现场都留下了一枚停摆的怀表。老刑警黄班长即将退休，却执意要办完最后一个案子。随着调查深入，他发现凶手似乎总能预料到警方的每一步行动。当年那个悬而未决的旧案，正在以同样的方式重演。时间在流逝，而真相就藏在每一块停摆的怀表里。",
  },
  {
    id: "dream-around",
    title: "寻梦环球",
    type: "movie",
    genres: ["动画", "冒险"],
    region: "美国",
    year: 2025,
    director: "Pix Martinez",
    actors: ["配音：Lily Adams", "配音：Ben Torres"],
    rating: 8.9,
    updatedAt: "2026-10-01",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20animated%20adventure%20movie%20poster%20with%20a%20cute%20cartoon%20hot%20air%20balloon%20flying%20over%20whimsical%20stylized%20lands%2C%20bright%20teal%20and%20orange%20palette%2C%20joyful%20imaginative%20mood%2C%20family%20film%20key%20art&width=600&height=900&seq=ttc-poster-12&orientation=portrait",
    tags: ["合家欢", "成长", "手绘风"],
    summary:
      "十岁的小女孩露娜偶然得到一张会发光的旧地图，据说它能指引人找到「世界尽头的那道彩虹」。为了完成爷爷未竟的旅行，露娜带着会说话的小狗和一只胆小的机械鸟，乘上热气球开始环游世界。一路上他们穿越会跳舞的沙漠、漂浮的城市和颠倒的森林。真正的冒险，是学会在旅途中成为更好的自己。",
  },
  {
    id: "wasteland-lord",
    title: "荒原之主",
    type: "movie",
    genres: ["战争", "剧情"],
    region: "英国",
    year: 2026,
    director: "Edward Nolan",
    actors: ["Robert Hale", "Grace Fowler", "Sam Reed"],
    rating: 8.3,
    updatedAt: "2026-09-30",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20war%20drama%20movie%20poster%20with%20soldiers%20marching%20across%20a%20desolate%20muddy%20plain%20at%20dusk%2C%20muted%20earthy%20brown%20and%20grey%20tones%2C%20somber%20powerful%20atmosphere%2C%20film%20key%20art&width=600&height=900&seq=ttc-poster-13&orientation=portrait",
    tags: ["史诗", "人性", "群像"],
    summary:
      "一战末期，一支被困在无人区的英军小队与指挥部彻底失去联系。上尉哈里森必须在敌军包围和内部矛盾之间，带领剩余的士兵找到回家的路。荒原上没有英雄，只有一群想活下去的普通人。当战争的宏大叙事褪去，留下的是一段关于勇气、牺牲与和解的真实故事。",
  },
  {
    id: "city-glimmer",
    title: "都市微光",
    type: "movie",
    genres: ["剧情", "喜剧"],
    region: "中国",
    year: 2025,
    director: "许安然",
    actors: ["刘星辰", "周雨桐", "陈嘉豪"],
    rating: 8.0,
    updatedAt: "2026-09-29",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20urban%20slice-of-life%20Chinese%20movie%20poster%20of%20friendly%20people%20in%20a%20cozy%20late-night%20street%20with%20string%20lights%2C%20soft%20amber%20and%20teal%20evening%20tones%2C%20heartwarming%20tender%20mood%2C%20film%20key%20art&width=600&height=900&seq=ttc-poster-14&orientation=portrait",
    tags: ["群像", "都市", "温情"],
    summary:
      "深夜十一点，城市渐渐安静下来，但总有一些小店还亮着灯。便利店店员、代驾司机、急诊科护士、失眠的编剧，四个看似毫无交集的人，因为一场突如其来的停电在街角相遇。他们分享着彼此的故事，也在这座巨大的城市里，找到了属于自己的那一点点微光。",
  },
  {
    id: "fog-city",
    title: "迷雾之城",
    type: "tv",
    genres: ["悬疑", "犯罪"],
    region: "中国",
    year: 2026,
    director: "孙浩",
    actors: ["胡明", "江雨薇", "李建"],
    rating: 9.0,
    updatedAt: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20mystery%20crime%20TV%20series%20poster%20with%20a%20grey%20foggy%20city%20skyline%20at%20dawn%20and%20a%20lone%20silhouette%20on%20a%20bridge%2C%20cold%20blue%20and%20grey%20tones%2C%20eerie%20suspenseful%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-15&orientation=portrait",
    tags: ["烧脑", "连环案", "口碑"],
    summary:
      "一座常年被浓雾笼罩的沿海城市，每隔十二年就会发生一起无法解释的失踪案。新调来的刑警队长沈越与法医苏晚联手调查，却逐渐发现这些案件竟与本地一个古老的家族传说息息相关。随着迷雾一次次散去又聚拢，真相被层层掩盖。而当沈越逼近核心时，他意识到，自己或许也是这盘棋里的一枚棋子。",
  },
  {
    id: "power-field",
    title: "权力游戏场",
    type: "tv",
    genres: ["剧情", "商战"],
    region: "美国",
    year: 2026,
    director: "Jonathan Reed",
    actors: ["Alex Turner", "Monica Bell", "David Kim"],
    rating: 8.8,
    updatedAt: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Prestige%20corporate%20drama%20TV%20series%20poster%20with%20a%20confident%20businesswoman%20standing%20before%20a%20glass%20skyscraper%20at%20night%2C%20elegant%20charcoal%20and%20gold%20tones%2C%20powerful%20sophisticated%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-16&orientation=portrait",
    tags: ["商战", "权谋", "大女主"],
    summary:
      "市值千亿的科技集团突然宣布更换掌门人，一个名不见经传的年轻女高管被推上了风口浪尖。在这场没有硝烟的战争中，董事会的每一次投票、每一份合同，都可能决定数万人的命运。盟友随时可能变成对手，而看似辅佐她的人，背后却各有盘算。权力是最好的试金石，也是最后的照妖镜。",
  },
  {
    id: "healer-heart",
    title: "医者仁心",
    type: "tv",
    genres: ["剧情", "医疗"],
    region: "中国",
    year: 2025,
    director: "郑海涛",
    actors: ["王凯", "杨蓉", "张晨光"],
    rating: 8.6,
    updatedAt: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20TV%20series%20poster%20with%20doctors%20in%20white%20coats%20walking%20through%20a%20bright%20modern%20hospital%20corridor%2C%20clean%20white%20and%20soft%20blue%20tones%2C%20warm%20hopeful%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-17&orientation=portrait",
    tags: ["医疗", "现实题材", "群像"],
    summary:
      "市中心医院的急诊科迎来了一位固执却医术高超的新主任。他坚持「先救人、后谈钱」，与院长推行的绩效制度格格不入。年轻的住院医师们夹在理想与现实之间，一次次在生死线上做出选择。每一集都是一个家庭的悲欢，也是一群医者对职业信念的坚守与追问。",
  },
  {
    id: "star-border",
    title: "星际边境",
    type: "tv",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2026,
    director: "Sarah Nguyen",
    actors: ["Lucas Ford", "Zoe Carter", "Ravi Menon"],
    rating: 8.7,
    updatedAt: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=Space%20opera%20TV%20series%20poster%20with%20a%20sleek%20starship%20gliding%20past%20a%20ringed%20planet%2C%20purple%20and%20teal%20nebula%2C%20glowing%20engine%20trails%2C%20grand%20cinematic%20sci-fi%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-18&orientation=portrait",
    tags: ["太空歌剧", "探索", "史诗"],
    summary:
      "在人类疆域的最后一颗殖民星上，一支边防舰队日复一日地守护着通往未知星域的航道。年轻的中尉艾拉在一次例行巡逻中，接收到了一段不属于任何已知文明的信号。这个发现让整支舰队卷入了联邦与叛军之间的博弈。宇宙辽阔而冰冷，而真正考验他们的，是该如何定义「家园」。",
  },
  {
    id: "jiangnan-past",
    title: "江南往事",
    type: "tv",
    genres: ["剧情", "年代"],
    region: "中国",
    year: 2026,
    director: "沈书言",
    actors: ["周韵", "陈道远", "刘莉莉"],
    rating: 8.9,
    updatedAt: "2026-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20period%20drama%20TV%20poster%20with%20a%20traditional%20water%20town%20along%20a%20canal%20with%20stone%20bridges%20and%20warm%20lanterns%2C%20muted%20jade%20green%20and%20amber%20tones%2C%20gentle%20melancholic%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-19&orientation=portrait",
    tags: ["年代", "家族", "口碑"],
    summary:
      "从上世纪三十年代到改革开放，江南水乡的沈家三代人经历了时代最剧烈的变迁。当家的祖母守着祖传的丝绸作坊，长子在战乱中远走他乡，小女儿则在新思潮中做出惊世骇俗的选择。一匹匹丝绸织出了家族的荣辱兴衰，也织出了一座水乡的百年记忆。",
  },
  {
    id: "detective-office",
    title: "侦探事务所",
    type: "tv",
    genres: ["悬疑", "喜剧"],
    region: "日本",
    year: 2025,
    director: "中村健",
    actors: ["木村拓海", "石原理惠", "田中一郎"],
    rating: 8.4,
    updatedAt: "2026-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=Quirky%20Japanese%20mystery%20comedy%20TV%20series%20poster%20with%20a%20cozy%20detective%20office%20full%20of%20books%20and%20clutter%2C%20warm%20yellow%20and%20brown%20tones%2C%20charming%20playful%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-20&orientation=portrait",
    tags: ["轻喜剧", "推理", "单元剧"],
    summary:
      "在城市某条不起眼的小巷里，有一家几乎从不接大案子的侦探事务所。所长是个爱吃泡面、永远睡不醒的怪人，助手则是刚毕业、满腔热血的推理迷。他们接手的案子千奇百怪：丢猫、寻人、抓出轨，却总能在鸡毛蒜皮里挖出意想不到的真相。轻松幽默的外壳下，藏着对人心的温柔洞察。",
  },
  {
    id: "dynasty-wind",
    title: "王朝风云",
    type: "tv",
    genres: ["历史", "剧情"],
    region: "中国",
    year: 2025,
    director: "郑晓龙",
    actors: ["张丰毅", "陈数", "黄志忠"],
    rating: 8.8,
    updatedAt: "2026-10-07",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20historical%20Chinese%20drama%20TV%20poster%20of%20an%20emperor%20on%20a%20throne%20in%20a%20vast%20hall%20with%20red%20pillars%2C%20deep%20crimson%20and%20gold%20tones%2C%20solemn%20majestic%20atmosphere%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-21&orientation=portrait",
    tags: ["正剧", "权谋", "群像"],
    summary:
      "一个王朝的兴衰，往往始于一场看似寻常的朝会。少年天子在权臣环伺中艰难亲政，太后、外戚、边将与文官集团各怀心思。每一次决策都是博弈，每一句话语都是刀锋。剧中没有绝对的好人与坏人，只有在时代洪流中挣扎求存的复杂人性。权力更迭的宏大叙事，落在每一个具体的人身上。",
  },
  {
    id: "silicon-valley",
    title: "硅谷风云",
    type: "tv",
    genres: ["剧情", "喜剧"],
    region: "美国",
    year: 2026,
    director: "Emily Zhang",
    actors: ["Ryan Cole", "Priya Nair", "Jake Foster"],
    rating: 8.5,
    updatedAt: "2026-10-06",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20tech%20startup%20comedy%20drama%20TV%20series%20poster%20with%20young%20diverse%20founders%20in%20a%20bright%20open%20office%20with%20whiteboards%2C%20clean%20white%20and%20vibrant%20orange%20accents%2C%20energetic%20optimistic%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-22&orientation=portrait",
    tags: ["创业", "科技圈", "讽刺"],
    summary:
      "三个刚毕业的年轻人怀揣着一个疯狂的 AI 点子，在硅谷租下一间车库开始创业。融资、挖人、内讧、被抄袭、一夜爆红又一夜崩盘，创业路上的每一步都充满荒诞与真实。当理想主义的初心遇上资本冰冷的规则，他们必须在「改变世界」和「活下去」之间找到平衡。",
  },
  {
    id: "youth-chronicle",
    title: "青春纪事",
    type: "tv",
    genres: ["青春", "爱情"],
    region: "韩国",
    year: 2026,
    director: "Kim Soo-jin",
    actors: ["Bae Suzy", "Nam Joo-hyuk", "Han Ji-min"],
    rating: 8.3,
    updatedAt: "2026-10-05",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20Korean%20high%20school%20romance%20TV%20series%20poster%20with%20students%20in%20uniforms%20laughing%20in%20a%20sunlit%20courtyard%2C%20fresh%20pastel%20pink%20and%20sky%20blue%20tones%2C%20youthful%20nostalgic%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-23&orientation=portrait",
    tags: ["校园", "初恋", "治愈"],
    summary:
      "高三那年，转学生河琳闯进了模范生道贤一成不变的生活。一个随性洒脱、一个循规蹈矩，两个截然不同的人在备考的日日夜夜里悄悄靠近。友情、暗恋、梦想与压力交织成最难忘的一年。多年后回望，那段兵荒马乱的青春，原来是人生里最清澈的时光。",
  },
  {
    id: "last-glow",
    title: "末日余晖",
    type: "tv",
    genres: ["科幻", "惊悚"],
    region: "美国",
    year: 2025,
    director: "Daniel Brooks",
    actors: ["Olivia West", "Marcus Hall", "Elena Ruiz"],
    rating: 8.2,
    updatedAt: "2026-10-04",
    cover:
      "https://readdy.ai/api/search-image?query=Post-apocalyptic%20sci-fi%20TV%20series%20poster%20with%20survivors%20standing%20on%20a%20ruined%20highway%20toward%20a%20dusty%20orange%20sunset%2C%20desolate%20wasteland%2C%20muted%20amber%20and%20grey%20tones%2C%20tense%20hopeful%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-24&orientation=portrait",
    tags: ["末世", "生存", "悬疑"],
    summary:
      "一场席卷全球的电磁风暴摧毁了几乎所有电子设备，文明在一夜之间倒退回原始状态。一群陌生人被困在一座废弃的地下车库里，他们必须为水、食物和药品争夺，也要面对彼此的不信任。当地表残留的辐射逐渐消散，一个更可怕的真相浮出水面：这场灾难或许并非天灾。",
  },
  {
    id: "cop-nature",
    title: "刑警本色",
    type: "tv",
    genres: ["犯罪", "动作"],
    region: "中国",
    year: 2026,
    director: "丁晟",
    actors: ["张译", "段奕宏", "倪妮"],
    rating: 8.7,
    updatedAt: "2026-10-03",
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20Chinese%20police%20crime%20TV%20series%20poster%20with%20plainclothes%20detectives%20in%20a%20dark%20interrogation%20room%2C%20hard%20cold%20blue%20and%20orange%20contrast%20lighting%2C%20tense%20determined%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-25&orientation=portrait",
    tags: ["刑侦", "硬核", "双雄"],
    summary:
      "刑警队里有一对出了名的「冤家搭档」：一个靠直觉办案冲锋在前，一个靠证据说话步步为营。两人性格水火不容，却在一桩跨国走私案中被迫联手。线索指向一个盘踞多年、根基极深的犯罪网络。当案件越来越接近核心，他们要面对的不仅是穷凶极恶的对手，还有来自内部的重重阻力。",
  },
  {
    id: "magic-academy",
    title: "魔法学院",
    type: "tv",
    genres: ["奇幻", "冒险"],
    region: "英国",
    year: 2026,
    director: "Charlotte Evans",
    actors: ["Harry Blake", "Freya Dunn", "Oliver Scott"],
    rating: 8.5,
    updatedAt: "2026-10-02",
    cover:
      "https://readdy.ai/api/search-image?query=Magical%20fantasy%20TV%20series%20poster%20of%20a%20grand%20ancient%20wizard%20academy%20campus%20at%20twilight%20with%20glowing%20windows%20and%20floating%20lanterns%2C%20deep%20emerald%20and%20violet%20tones%2C%20mystical%20enchanting%20mood%2C%20drama%20key%20art&width=600&height=900&seq=ttc-poster-26&orientation=portrait",
    tags: ["奇幻", "校园", "冒险"],
    summary:
      "在群山环绕的古老城堡里，只有被魔法选中的少年才能进入学院学习。新生哈利意外觉醒了一种早已失传的古老魔力，也因此被卷入了学院延续百年的秘密。图书馆禁地、会说话的画像、消失的校长，一个个谜团等待解开。当黑暗势力再次苏醒，这群年轻学徒必须学会为彼此而战。",
  },
];